import * as React from 'react';

type IProps = React.PropsWithChildren<{
	open: boolean;
	toggle: (open: boolean) => void;
}>;

class SideDrawer extends React.Component<IProps> {
	constructor(props) {
		super(props);

		this.hideDrawerListener = this.hideDrawerListener.bind(this);
	}

	private drawerRef = React.createRef<HTMLElement>();

	public componentDidMount(): void {
		document.addEventListener('click', this.hideDrawerListener);
	}

	public componentWillUnmount(): void {
		document.removeEventListener('click', this.hideDrawerListener);
	}

	private hideDrawerListener(e: MouseEvent) {
		if (!e || !e.target || !this.drawerRef.current || !this.props.open) {
			return;
		}
		if (!(e.target instanceof Element || e.target instanceof HTMLDocument)) {
			return;
		}
		if (!e.target.isConnected) {
			return;
		}
		if (this.drawerRef.current === e.target || this.drawerRef.current.contains(e.target)) {
			return;
		}
		const modals = document.querySelectorAll('.modal');
		for (var i = 0, len = modals.length; i < len; i++) {
			const modal = modals[i];
			if (modal.contains(e.target) && !modal.contains(this.drawerRef.current)) {
				return;
			}
		}
		this.props.toggle(false);
	}

	public render() {
		return (
			<aside className={'drawer ' + (this.props.open ? 'open' : 'closed')} ref={this.drawerRef}>
				{this.props.children}
			</aside>
		);
	}
}

export { SideDrawer };
